import Aurelia from 'aurelia';
import { RouterConfiguration } from '@aurelia/router';
import { SVGAnalyzer } from '@aurelia/runtime-html';
import { MyApp } from './my-app';
import { MoneyValueConverter, MmssValueConverter, AgoValueConverter, DecadeValueConverter, OddsValueConverter, PctValueConverter } from './resources/converters';
import { BallColorValueConverter } from './resources/balls';
import './styles/app.css';

Aurelia
  .register(
    RouterConfiguration.customize({ useUrlFragmentHash: false, useHref: false }),
    SVGAnalyzer,
    MoneyValueConverter, MmssValueConverter, AgoValueConverter, DecadeValueConverter, OddsValueConverter, PctValueConverter, BallColorValueConverter,
  )
  .app(MyApp)
  .start();
